import {
    GET_PRE_REGISTRATION_REJECTIONS_FAIL,
    GET_PRE_REGISTRATION_REJECTIONS_SUCCESS,
    ADD_NEW_PRE_REGISTRATION_REJECTION,
    ADD_NEW_PRE_REGISTRATION_REJECTION_SUCCESS,
    ADD_NEW_PRE_REGISTRATION_REJECTION_FAIL,
    UPDATE_PRE_REGISTRATION_REJECTION_SUCCESS,
    UPDATE_PRE_REGISTRATION_REJECTION_FAIL,
    DELETE_PRE_REGISTRATION_REJECTION_SUCCESS,
    DELETE_PRE_REGISTRATION_REJECTION_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    preRegistrationRejections: [],
    error: null,
    loading: false,
    actionSuccess: false,
};

const preRegistrationRejectionReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des preRegistrationRejections
        case GET_PRE_REGISTRATION_REJECTIONS_SUCCESS:
            return {
                ...state,
                preRegistrationRejections: action.payload, // tableau d'objets preRegistrationRejection
                loading: false,
                error: null
            };

        case GET_PRE_REGISTRATION_REJECTIONS_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une preRegistrationRejectione

        case ADD_NEW_PRE_REGISTRATION_REJECTION:
            return {
                ...state,
                loading: true,
                actionSuccess: false,
                error: null,
            };


        case ADD_NEW_PRE_REGISTRATION_REJECTION_SUCCESS:
            return {
                ...state,
                preRegistrationRejections: [action.payload, ...state.preRegistrationRejections], // ajoute au début du tableau
                error: null,
                actionSuccess: true,
            };

        case ADD_NEW_PRE_REGISTRATION_REJECTION_FAIL:
            return {
                ...state,
                error: action.payload,
                actionSuccess: false,
            };

        // Mise à jour d'une preRegistrationRejectione
        case UPDATE_PRE_REGISTRATION_REJECTION_SUCCESS:
            return {
                ...state,
                preRegistrationRejections: state.preRegistrationRejections.map(preRegistrationRejection =>
                    preRegistrationRejection.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet preRegistrationRejection
                        : preRegistrationRejection
                ),
                error: null
            };

        case UPDATE_PRE_REGISTRATION_REJECTION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une preRegistrationRejectione
        case DELETE_PRE_REGISTRATION_REJECTION_SUCCESS:
            return {
                ...state,
                preRegistrationRejections: state.preRegistrationRejections.filter(
                    preRegistrationRejection => preRegistrationRejection.id !== action.payload
                ),
                error: null
            };


        case DELETE_PRE_REGISTRATION_REJECTION_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case "RESET_PRE_REGISTRATION_REJECTION_ACTION":
            return {
                ...state,
                actionSuccess: false,
                error: null,
            };

        default:
            return state;
    }
};

export default preRegistrationRejectionReducer;
